import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { ContentWrapper } from '../../components/content-wrapper';
import { useSurveyBuilderDesktopViewport } from '../../pages/admin/surveys/survey-builder-responsive-policy';

export function SurveyBuilderDesktopOnlyGuard() {
  const { t } = useTranslation();
  const isDesktop = useSurveyBuilderDesktopViewport();

  if (isDesktop) {
    return <Outlet />;
  }

  return (
    <ContentWrapper>
      <Alert severity="info">
        <AlertTitle>{t('admin.surveys.builder.desktopOnly.title')}</AlertTitle>
        {t('admin.surveys.builder.desktopOnly.description')}
      </Alert>
    </ContentWrapper>
  );
}
